<template>
	<main id="main" class="single page main margin-bottom-lg" :key="currentPageID">
		<SingleHeading v-if="!isProtected" />
		<transition :style="{ '--totalStagger': 4 }" name="slide-in" appear>
			<PageWrapper :style="'--indexStagger: 4'">
				<FeaturedImage
					size="large"
					class="container margin-auto margin-bottom-lg margin-top-lg"
					v-if="!isProtected"
				/>
				<ModuleBuilder v-if="!isProtected" />
				<PasswordProtection v-else />
			</PageWrapper>
		</transition>
	</main>
</template>

<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import PasswordProtection from '@/components/parts/PasswordProtection'
import SingleHeading from '@/components/parts/SingleHeading'
import FeaturedImage from '@/components/parts/FeaturedImage'
import PageWrapper from '@/components/elements/PageWrapper'

import { mapGetters } from 'vuex'

export default {
	name: 'single-page',
	components: {
		ModuleBuilder,
		PasswordProtection,
		SingleHeading,
		FeaturedImage,
		PageWrapper,
	},
	computed: {
		...mapGetters(['currentPage', 'currentPageID']),
		isProtected() {
			let isProtected = false
			if (this.currentPage && this.currentPage.is_protected === true) {
				isProtected = true
			}
			return isProtected
		},
	},
	mounted() {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.page {
}
</style>
